import type { PaymentOverview } from '@weft/api-definition';
import { sortBy } from 'lodash';
import React, { useMemo } from 'react';
import type { VyTableMinimalProps } from '../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../components/new-design/table/vy-table/VyTable';
import { PAYMENTS_COLUMNS_KEYS, PAYMENT_OVERVIEW_TABLE_COLUMNS } from './payment-columns';

export const PaymentsOverviewTable: React.FC<VyTableMinimalProps<PaymentOverview>> = ({ items, ...props }) => {
  const sortedPaymentsByDate = useMemo(() => sortBy<PaymentOverview>(items, 'updatedAt').reverse(), [items]);

  return (
    <VyTable
      columns={PAYMENT_OVERVIEW_TABLE_COLUMNS}
      items={sortedPaymentsByDate}
      {...props}
      sx={{
        paddingBottom: '160px',
      }}
      initialState={{
        sorting: {
          sortModel: [
            {
              field: PAYMENTS_COLUMNS_KEYS.CREATION_TIME,
              sort: 'desc',
            },
          ],
        },
      }}
    />
  );
};